import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { TrialBannerComponent } from './trial-banner/trial-banner.component';

@NgModule({
  imports: [CommonModule, TranslateModule, GalaxyAlertModule, GalaxyPipesModule],
  declarations: [TrialBannerComponent],
  exports: [TrialBannerComponent],
})
export class TrialBannerModule {}
